<template>
  <div>
    <a-row>
      <a-col :xs="{span:22,offset:1}" :md="{span:18,offset:3}" :xl="{span:16,offset:4}">
        <h1>Personaleinsatz auswerten</h1>
        <p>
          Das Coronavirus hat die Weltwirtschaft fest im
          Griff. Nach einem beispiellosen Shutdown steht
          der Gastronomie nun die lang ersehnte Wiedereröffnung bevor. Sicher ist bereits, dass die Wiedereröffnung nur schrittweise erfolgen wird und
          es weiterhin zu massiven Einschränkungen
          kommt. So können Restaurants für längere Zeit
          nur mit reduzierten Kapazitäten betrieben werden. Spätestens bei der Planung der Wiedereröffnung stellen sich für jedes Restaurant
          zwei Fragen:
        </p>
        <ol>
          <li><b>Mit welchem Umsatz und wie vielen Gästen kann bei reduzierten Kapazitäten gerechnet werden?</b></li>
          <li><b>Welche Personalbesetzung ist notwendig, sodass sich das wirtschaftlich lohnt?</b></li>
        </ol>
        <p>
          Diese Fragen können Sie mit diesem Online-Tool beantworten (kostenlos &amp; anonym). Konkret können Sie mit diesem Tool...
        </p>
        <ul>
          <li>... Ihre erwarteten Umsätze planen</li>
          <li>... den optimalen Personaleinsatz ermitteln und optimieren (pro Station und in Abhängigkeit vom Umsatz)</li>
          <li>... Ihre Öffnungszeiten zielorientiert anpassen</li>
        </ul>
        <p>
          Für die Berechnung begleitet Sie das Tool durch vier einfache Schritte. Dabei können Sie jederzeit zu einem vorherigen Schritt zurück, um die Eingaben zu verändern. So können Sie direkt die Auswirkungen der Veränderungen testen. 
        </p>
        <p>
          Details und Hintergründe zu den Berechnungen können im Whitepaper "Restaurants in der Krise profitabel steuern" nachgelesen werden (<a href="https://nesto-software.de/wp-content/uploads/2020/05/Nesto_Whitepaper_Restaurants-in-der-Krise-profitabel-steuern.pdf">zum Whitepaper</a>).
        </p>
        <div style="text-align: center; margin: 2rem;">
          <a-button type="primary" @click="onStart">
            Jetzt starten!
          </a-button>
        </div>
        <p>
          <i>Hinweis:</i> Die Verwendung dieses Software-Tools ist kostenlos und anonym. Die eingegebenen Daten werden ausschließlich auf Ihrem Computer verarbeitet und <b>nicht</b> übertragen. So ist die Vertraulichkeit Ihrer Daten gewährleistet. Bitte beachten Sie, dass beim Verlassen der Seite Ihre Daten gelöscht werden und somit bei einem späteren Aufruf erneut eingegeben werden müssen.
        </p>
        <p>Das gesamte Nesto-Team wünscht Ihnen viel Spaß bei der Verwendung des Tools und eine erfolgreiche Wiedereröffnung!</p>
      </a-col>
    </a-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Antd from 'ant-design-vue';
import Vue from "vue";
import "ant-design-vue/dist/antd.css";
import router from '../router';

Vue.use(Antd);

export default {
  name: "Home",
  components: {
  },
  methods: {
    onStart:function(){
      router.push("restaurantparameter");
      window.scrollTo(0,0);
    }
  }
};
</script>
